<rt-form-field variant="underlined search">
  <rt-icon name="link"></rt-icon>
  <rt-input
    (keyup.enter)="exit.next()"
    [autoFocus]="true"
    [formControl]="formControl"
    [hasClearButton]="false"
    placeholder="https://recruitee.com/"
    variant="underlined"
  ></rt-input>
  <rt-button (click)="removeLink.next()" [insideInput]="true" variant="plain only-icon">
    <rt-icon name="close" size="small"></rt-icon>
  </rt-button>
</rt-form-field>
<div class="arrow"></div>
